<footer class="admin-footer">
  <span>&copy; {{ currentYear }} Amaal Momineen Admin. All rights reserved.</span>
</footer>
